let nextIdTest = 0;

export const addDeliveryOrder = (articleType, articleEntry, articleSysId, sizeEntry, numberInput, image ) => ({
    type: 'ADD_ORDER_ENTRY',
    id: nextIdTest++,
    articleType: articleType,
    articleEntry: articleEntry,
    articleSysId: articleSysId,
    sizeEntry: sizeEntry,
    numberInput: numberInput,
    image: image
})

export const removeDeliveryOrder = (articleType, articleSysId) => ({
    type: 'REMOVE_ORDER_ENTRY',
    articleType: articleType,
    articleSysId: articleSysId
})

export const addStock = (articleType, articleEntry, articleSysId, sizeEntry, numberInput, image) => ({
    type: 'ADD_STOCK',
    articleType: articleType,
    articleEntry: articleEntry,
    articleSysId: articleSysId,
    sizeEntry: sizeEntry,
    numberInput: numberInput,
    image: image
})

export const addSizes = (articleEntry, sizes) => ({
    type: 'ADD_SIZE_ENTRY',
    articleEntry: articleEntry,
    sizes: testing(sizes),
})

export const showSizes = (articleEntry, sizes) => ({
    type: 'SHOW_SIZE_ENTRY',
    articleEntry: articleEntry,
    sizes: sizes
})

export const showSizes2 = (articleEntry, sizes) => ({
    type: 'SHOW_SIZE_ENTRY2',
    articleEntry: articleEntry,
    sizes: sizes
})

export const addArticleType = (articleNumber, sizeCat, name, gender, style, price, image, sizeEntries) => ({
    type: 'ADD_ARTICLETYPE',
    articleNumber: articleNumber,
    sizeCat: sizeCat,
    name: name,
    gender: gender,
    style: style,
    price: price,
    image: image,
    sizeEntries: sizeEntries
})

export const updateArticleType = (articleNumber, name, gender, style, price, sizeCat) => ({
    type: 'UPDATE_ARTICLETYPE',
    articleNumber: articleNumber,
    name: name,
    gender: gender,
    style: style,
    price: price,
    sizeCat: sizeCat
})

export const addArticleTypeInputs = (articleNumber, sizeCat, name, gender, style, price, isValid) => ({
    type: 'ADD_ARTICLETYPE_INPUTS',
    articleNumber: articleNumber,
    sizeCat: sizeCat,
    name: name,
    gender: gender,
    style: style,
    price: parseFloat(price).toFixed(2).replace('.', ','),
    isValid: isValid
})

export const addArticleTypeImage = (image) => ({
    type: 'ADD_ARTICLETYPE_IMAGE',
    image: image
})

export const updateArticleTypeInputs = (articleNumber, name, gender, style, price, sizeCat, isValid) => ({
    type: 'UPDATE_ARTICLETYPE_INPUTS',
    articleNumber: articleNumber,
    name: name,
    gender: gender,
    style: style,
    price: parseFloat(price).toFixed(2).replace('.', ','),
    sizeCat: sizeCat,
    isValid: isValid
})

export const dummy_addToStock = (addStock) => ({
    type: 'DUMMY_ADD_TO_STOCK',
    addStock: addStock
})

export const dummy_removeFromStock = (addStock) => ({
    type: 'DUMMY_REMOVE_FROM_STOCK',
    addStock: addStock
})

export const dummy_resetAddStock = () => ({
    type: 'RESET_ADD_STOCK',
})

export const dummy_resetAddDelivery = () => ({
    type: 'RESET_ADD_DELIVERY',
})


const testing = (sizes) => {
    console.log("AddSizes: " + sizes)
    return sizes;
}